import { FC } from "react";
import { MenuProps } from "../types";
import { useStoreState } from "../store/useStore";
import {
  activeRouteStyles,
  dropDownStylesDesText,
  dropDownStylesText,
  iconStyles,
  stylesBg,
  stylesGroupText,
  stylesHover
} from "../styles";
import ArrowIcon from "../../assets/header/arrow.svg?react";
import { useTranslations } from "use-intl";
import { Languages, LanguagesType } from "../../types";
import { getCurrentPath } from "./getActiveClass";
import Hot from "../Hot";

const Menu: FC<{ menus: MenuProps; changeRoute?: (route: string) => void }> = ({
  menus,
  changeRoute
}) => {
  const { theme, localeLink, locale } = useStoreState();

  const t = useTranslations("header");

  const changeRouter = (item: MenuProps, e: React.MouseEvent<HTMLAnchorElement>) => {
    if (changeRoute) {
      e.preventDefault();
      if (!item.items) {
        if (item.basePath) {
          changeRoute(`/${item.basePath}${localeLink}/${item.url}`);
        } else {
          changeRoute(`${localeLink}/${item.url}`);
        }
      }
    }
  };

  const childRoute = (url: string, basePath: string) => {
    return `/${basePath}${localeLink}/${url}`;
  };

  return (
    <div className={`flex items-center relative max-[1000px]:h-[64px] group`}>
      <span
        className={`h-[64px] flex items-center text-[14px] cursor-pointer ${
          getCurrentPath(menus.activeRouts)
            ? activeRouteStyles({
                mode: theme
              })
            : ""
        } ${stylesGroupText({
          mode: theme
        })}`}
      >
        {
          Languages[locale as LanguagesType].header[
            menus.label as keyof (typeof Languages)[LanguagesType]["header"]
          ]
        }
        <ArrowIcon
          className={`group-hover:rotate-180 ml-[2px] ${
            getCurrentPath(menus.activeRouts)
              ? activeRouteStyles({
                  mode: theme
                })
              : ""
          } ${stylesGroupText({
            mode: theme
          })} `}
        />
      </span>
      <div
        className={`invisible overflow-hidden group-hover:visible flex-col absolute top-[50px] py-[12px] rounded-[8px] shadow-[0_2px_20px_rgba(0,0,0,.12)] ${stylesBg(
          { mode: theme }
        )}`}
      >
        {menus.items?.map((item, index) => {
          return (
            <a
              href={
                item.basePath ? childRoute(item.url!, item.basePath) : `${localeLink}/${item.url}`
              }
              key={index}
              onClick={(e) => {
                if (item.clickFunc) {
                  item.clickFunc(e);
                } else {
                  changeRouter(item, e);
                }
              }}
            >
              <div
                className={`flex items-center ${locale === "es" ? "w-[380px]" : "w-[360px]"} px-[24px] py-[12px] cursor-pointer ${stylesBg(
                  {
                    mode: "light"
                  }
                )} ${stylesHover({ mode: "light" })}`}
              >
                {item.icon && <item.icon className={iconStyles({ mode: "light" })} />}
                <div className="flex flex-col">
                  <span
                    className={`text-[14px] leading-[20px] flex ${dropDownStylesText({
                      mode: "light"
                    })}`}
                  >
                    {t(item.label)}{" "}
                    {item.hotText && (
                      <Hot
                        theme={theme}
                        className="w-[88px]"
                        fontSize="text-[12px]"
                        text={item.hotText}
                      />
                    )}
                  </span>
                  <span
                    className={`text-[12px] leading-[18px] ${dropDownStylesDesText({
                      mode: "light"
                    })}`}
                  >
                    {t(item.des)}
                  </span>
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default Menu;
